<script>
import DailyOther from "@/views/count/other/DailyOther.vue";

export default {
  components: { DailyOther},
  data() {
    return {
      period: '温度报表'
    }
  },
  methods: {
    init() {
    },
  },
  mounted() {
    this.init();
  }
}
</script>

<template>
  <el-container style="padding: 20px;">
    <el-tabs v-model="period" style="width: 100%;">
      <el-tab-pane label="温度报表" name="温度报表">
        <div style="width: 100%;height: 100%;background-color: white">
            <daily-other></daily-other>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-container>
</template>

<style scoped>
/* 按钮样式 */
::v-deep .queryButton {
  font-family: PingFang SC;
  font-size: 1.4rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  border-radius: 0.5rem;
  margin-left: 1.5rem;
}

::v-deep .queryButtonPadding {
  padding-left: 2rem;
  padding-right: 2rem;
}

::v-deep .qDcBtn {
  position: absolute;
  right: 4rem;
}

::v-deep .qDcImg {
  width: 1.2rem;
  height: 1.2rem;
}
</style>
